import InputField1 from "../../../../components/ui/InputField1"
import { Grid2 as Grid } from "@mui/material"
import { Fragment } from "react"
import { useSelector } from "react-redux"


function TaiChi({ errors, files, onChangFun }) {
  const { specialist } = useSelector(state => state.specialistSlice)

  return (
    <Fragment>
      <Grid size={12}>
        <InputField1
          type="textarea"
          errors={errors}
          name="taiChiStyles"
          label="Tai Chi Styles *"
          errText="Please enter tai chi styles"
          defaultValue={specialist?.profile?.taiChiStyles || ""}
          placeholder="Describe the styles of Tai Chi you teach, such as Yang, Chen, Wu, etc"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="textarea"
          errors={errors}
          name="teachingExperience"
          label="Teaching Experience * "
          errText="Please enter teaching experience"
          placeholder="Detail your experience as a Tai Chi instructor, including years of teaching and notable achievements"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="textarea"
          errors={errors}
          name="qualification"
          label="Certifications and Qualifications *"
          defaultValue={specialist?.profile?.qualification || ""}
          errText="Please enter certifications and qualifications"
          placeholder="List your certifications and qualifications in Tai Chi"
        />
      </Grid>
    </Fragment>
  )
}

export default TaiChi